import { Field, Int, InputType } from 'type-graphql'
import type { IAction } from '../../../action/IAction'
import { ActionArgs } from '../../../action/ActionArgs'
import type { AiCreditTransaction } from '../AiCreditTransaction'

@InputType()
export class GrantOnboardingCreditsArgs extends ActionArgs {
  /** Number of credits to grant — a caller-supplied business decision, not an engine constant. */
  @Field(() => Int)
  credits: number

  /** Ledger reason recorded on the resulting `AiCreditTransaction` row. */
  @Field()
  reason: string
}

/**
 * Router-invoked only (never GraphQL-exposed) — called from the QuickScore mobile registration
 * hooks after a teacher account is stamped active for the first time.
 */
export interface IGrantOnboardingCredits extends IAction<AiCreditTransaction, GrantOnboardingCreditsArgs> {}
